import { render } from "./HeroiconsSolidDocumentSearch.vue?vue&type=template&id=da0f1e54"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentSearch.vue"]])

export default __exports__